import React from "react";
import TextField from "@mui/material/TextField";
import { SearchIcon } from "assets/iconsSVG";
import color from "constants/color";
import * as S from "./styles";

interface Props {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  label?: string;
  value: string;
  placeholder?: string;
  type?: string;
  width?: string;
  disabled?: boolean;
  borderRadius?: string;
  buttonAction?: () => void;
  onKeyPress?: (event: React.KeyboardEvent) => void;
  rows?: number;
  isError?: boolean;
  multiline?: boolean;
  helperText?: string;
}

const InputComponent: React.FC<Props> = ({
  onChange,
  onBlur,
  label,
  type,
  value,
  placeholder,
  width = "100%",
  disabled = false,
  borderRadius = "8px",
  buttonAction,
  onKeyPress,
  isError = false,
  rows,
  helperText,
  multiline = false,
}) => {
  return (
    <S.Container width={width}>
      {label && (
        <S.Label color={isError ? "red" : color?.black}>{label}</S.Label>
      )}
      <TextField
        value={value}
        type={type}
        onKeyPress={onKeyPress}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        variant="outlined"
        size="small"
        fullWidth
        multiline={multiline}
        rows={rows}
        minRows={multiline ? rows : undefined}
        maxRows={multiline ? rows : undefined}
        InputProps={{
          endAdornment: buttonAction ? (
            <S.IconButton onClick={buttonAction}>
              <SearchIcon />
            </S.IconButton>
          ) : null,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius,
            backgroundColor: disabled ? "#D0D5DD" : "#ffffff",
          },
          "& input::placeholder": {
            textOverflow: "ellipsis !important",
          },
          "& textarea::placeholder": {
            textOverflow: "ellipsis !important",
          },
        }}
      />
      {isError && helperText && <S.Helper>{helperText}</S.Helper>}
    </S.Container>
  );
};

export default InputComponent;
